export default __webpack_public_path__ + "static/media/r6.06656f6e.jpeg";